import http from 'hub-http/clients/apiClient';
const API_BASE = '/navconfig/v2/home/options';
export default class NavConfigAPI {
  static getHomePageOptions() {
    return http.get(API_BASE);
  }
}